
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Boulogne-Billancourt dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Boulogne-Billancourt certifiée Google Partner, accompagne les entreprises boulonnaises pour accroître leur présence en ligne et attirer de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Boulogne-Billancourt dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Boulogne-Billancourt certifiée Google Partner, accompagne les entreprises boulonnaises pour accroître leur présence en ligne et attirer de nouveaux clients.",
        },
      ],
    };
  },
};
